import React from 'react';
import { ClampedLineTitle, ComponentWrapper, ImageContainer, TextContainer } from 'app/components/competitionModule/news/commonStyles';
import { Skeleton } from '@mui/material';
export default function NewsComponentSkeleton() {
  return /*#__PURE__*/React.createElement(ComponentWrapper, {
    "data-sentry-element": "ComponentWrapper",
    "data-sentry-component": "NewsComponentSkeleton",
    "data-sentry-source-file": "NewsComponentSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rounded",
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "NewsComponentSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "NewsComponentSkeleton.tsx"
  })), /*#__PURE__*/React.createElement(TextContainer, {
    "data-sentry-element": "TextContainer",
    "data-sentry-source-file": "NewsComponentSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "NewsComponentSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(ClampedLineTitle, {
    "data-sentry-element": "ClampedLineTitle",
    "data-sentry-source-file": "NewsComponentSkeleton.tsx"
  }, "Hier ist ein einzeiliger Titel")), /*#__PURE__*/React.createElement(Skeleton, {
    height: 14,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "NewsComponentSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 14,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "NewsComponentSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 14,
    width: "80%",
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "NewsComponentSkeleton.tsx"
  })));
}